import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RestServiceAbstract } from '../../../core/base/rest.service.abstract';
import { ResponseModel } from '../../../core/base/response.model';
import { ReturnConditionData } from '../models/return.condition.data';

@Injectable({
  providedIn: 'root',
})
export class ReturnConditionsRestService extends RestServiceAbstract{
  private readonly destroyRef = inject(DestroyRef);

  public loadReturnConditions(idf: string): Observable<ResponseModel> {
    return this.get(`/${this.USERMANAGEMENT}/return-conditions/${idf}`).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: object) => new ResponseModel<ReturnConditionData>(data)),
      catchError((err: unknown) => throwError(() => err))
    );
  }
}
